module.exports = __webpack_public_path__ + "static/specialization_line_bg-5eacf28861cd555f7d91861575411fda.svg";